<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" :title="onDialogTitle">
        <div class="mt-2">
          <span class="red--text">*</span> 는 필수입력항목입니다.
        </div>
        <v-form lazy-validation ref="form">

          <v-container>
            <v-row align="center">
              <v-col cols="5">
                <span class="ml-1 mb-2">차종</span><span class="red--text">*</span>
                <v-select
                  dense
                  v-model="seatCnt"
                  :items="getSeatCnt"
                  item-text="configName"
                  item-value="configValue"
                  solo
                  menu-props="{offsetY: true}"
                  hide-details
                  required
                  placeholder="차종을 선택해주세요"
                  :rules="[v => !!v]"
                  :disabled="!isNew"
                  color="navy"
                ></v-select>
              </v-col>
              <v-col cols="7">
                <span class="ml-1 mb-2">모델명</span>
                <v-text-field v-model="modelName" :placeholder="modelNamePlaceHolder" solo dense required :rules="[v => !!v]"
                                hide-details color="navy" maxlength="32"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <c-btn v-if="isNew" color="blue" class="mr-1 mt-2" outlined @click="onAddVehicleModel">등록</c-btn>
              <c-btn v-else class="mr-1 mt-2" color="blue" outlined @click="onUpdateVehicleModel">수정</c-btn>
              <c-btn class="mt-2" color="gray" outlined @click="() => { this.openFlag = false; }">취소</c-btn>
            </v-row>
          </v-container>
        </v-form>

      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import {mask} from 'vue-the-mask';
import InfiniteScrollTablesVue from '../../_dev/InfiniteScrollTables.vue';

  export default {
    directives: {mask},
    props: {
      open: {
        type: Boolean,
        default: false
      },
      vehicleModelFormData: {
        type: Object,
        default: undefined
      },
    },
    data: () => ({
      openFlag: false,
      isNew: true,
      seatCnt: '',
      modelName: '',
      modelNamePlaceHolder: '(ex. 스타렉스, 스파크 2019년형 ...)'
    }),
    mounted() {
    },
    watch: {
      open(value) {
        if ( value && this.vehicleModelFormData && this.vehicleModelFormData.id ) {
          this.isNew = false;
          this.id = this.vehicleModelFormData.id;
          this.seatCnt = this.vehicleModelFormData.seatCnt;
          this.modelName = this.vehicleModelFormData.modelName;
          this.modelNamePlaceHolder = this.vehicleModelFormData.modelName;
        } else {
          this.isNew = true;
          this.id = '';
          this.seatCnt = '';
          this.modelName = '';
          this.modelNamePlaceHolder = '(ex. 스타렉스, 스파크 2019년형 ...)';
        }

        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
    },
    computed: {
      getSeatCnt() {
        const sortSeatCnt = this.$store.state.config.seat_cnt;
        const strArr = new Array();
        const strMap = new Map();
        for (var i = 0; i < sortSeatCnt.length; i++) {
            if (!sortSeatCnt[i].configName.includes("인승")) {
                strArr.push(sortSeatCnt[i].configName);
            }
        }
        strArr.sort();
        var idx = 100;
        for (var i = 0; i < strArr.length; i++) {
            strMap.set(strArr[i], idx++);
        }
        for (var i = 0; i < sortSeatCnt.length; i++) {
            if (sortSeatCnt[i].configName.includes("인승")) {
                sortSeatCnt[i].idx = Number(sortSeatCnt[i].configName.replace("인승", ""));
            } else {
                sortSeatCnt[i].idx = strMap.get(sortSeatCnt[i].configName);
            }
        }
        sortSeatCnt.sort(function (a, b) {
            return (a.idx < b.idx) ? -1 : (a.idx > b.idx) ? 1 : 0;
        });
        return sortSeatCnt.map(c => ({ configName: c.configName, configValue: c.configValue }));
      },
      onDialogTitle() {
        return this.isNew ? '차량 모델 정보 등록' : '차량 모델 정보 수정';
      },
    },
    methods: {
      onAddVehicleModel() {
        // if (!(this.$refs.form.validate())) {
        if (!this.seatCnt || !this.modelName) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }

        let reqData = {
          seatCnt: this.seatCnt,
          modelName: this.modelName,
        }
        this.$emit('reqAddVehicleModel', reqData);
      },
      onUpdateVehicleModel() {
        if (!this.modelName) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }

        let reqData = {
          id: this.vehicleModelFormData.id,
          modelName: this.modelName,
        }
        this.$emit('reqUpdateVehicleModel', reqData);
      },
    },
  }
</script>
<style lang="scss">

</style>
